import React, { useCallback, useMemo, useState } from 'react'
import { IconName } from '~components/Icon'
import { Dropdown, StyledDropdown } from '~components/Dropdown'
import { Input } from '../TextualFormElement'
import { ComponentProps } from './Select.types'

export interface Props extends ComponentProps {
  selectedKeys?: string[]
}

const MultiSelect: React.FC<Props> = ({
  onSelect,
  selectedKeys,
  options,
  size,
  isDisabled,
  isError,
  placeholder,
  zIndex,
  variant,
  arrowPosition,
  className,
  placement = 'bottom-start',
  separator = ',',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const selectedOptionsValues = useMemo(
    () =>
      options
        .filter(o => selectedKeys?.includes(o.key))
        .map(o => o.value)
        .join(separator),
    [selectedKeys, separator],
  )

  const inputField = useCallback(
    (disabled: boolean) => {
      const arrowIcon = isOpen ? IconName.chevron_up : IconName.chevron_down

      return (
        <Input
          readOnly={true}
          size={size}
          isError={isError}
          disabled={disabled}
          placeholder={placeholder}
          value={selectedOptionsValues}
          variant={variant}
          {...(arrowPosition === 'left' ? { icon: arrowIcon } : { iconRight: arrowIcon })}
        />
      )
    },
    [size, isError, placeholder, isOpen, selectedOptionsValues],
  )

  return isDisabled ? (
    inputField(true)
  ) : (
    <Dropdown isOpen={isOpen} onOpenChange={setIsOpen} placement={placement} shouldDismissOnClick={false} zIndex={zIndex}>
      {inputField(false)}

      <StyledDropdown.Content className={className}>
        {options.map(o => (
          <StyledDropdown.CheckboxOption key={o.key} onClick={() => onSelect(o)}>
            <StyledDropdown.OptionIcon name={selectedKeys?.includes(o.key) ? IconName.check : IconName.empty} />
            {o.value}
            {o.caption && <StyledDropdown.OptionCaption>{o.caption}</StyledDropdown.OptionCaption>}
          </StyledDropdown.CheckboxOption>
        ))}
      </StyledDropdown.Content>
    </Dropdown>
  )
}

MultiSelect.displayName = 'MultiSelect'
export default MultiSelect
